import { STATUS_CODE_UNAUTHORIZED } from '../constants'
import { router } from '../router'
import { useAuthStore } from '@/store/index'
import axios from 'axios'
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { storeToRefs } from 'pinia'
import { toast } from 'vue-sonner'

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === STATUS_CODE_UNAUTHORIZED) {
      const { logout } = useAuthStore()
      logout()

      if (
        window.location.pathname !== '/login' &&
        window.location.pathname !== '/'
      ) {
        toast.warning('Your session has expired. Please login again.')
        router.push({ name: 'auth.login' })
      }
    }

    return Promise.reject(error)
  },
)

export async function request<TData = any>(
  option: AxiosRequestConfig,
): Promise<any> {
  const { profile } = storeToRefs(useAuthStore())
  return axiosInstance
    .request({
      ...option,
      baseURL: import.meta.env.VITE_APP_API_URL,
      headers: {
        'Content-Type': 'application/json',
        ...option?.headers,
        Authorization: 'Bearer ' + window.localStorage.getItem('auth'),
        ...(profile.value?.owner?.code && {
          'X-Insurer': profile.value?.owner?.code,
        }),
      },
    })
    .then((response: AxiosResponse<TData>) => response.data)
    .catch((error: AxiosError<any>) => {
      throw error
    })
}

export function fileUploadRequest(file: File) {
  const form = new FormData()
  form.append('file', file)
  return request({
    url: 'api/uploads',
    method: 'post',
    data: form as any,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function fileDeleteRequest(id: Number) {
  return request({
    url: `api/v1/uploads/${id}`,
    method: 'delete',
  })
}
